import * as React from 'react'

export default function HorizontalTitledSeparatorComponent ({ className, children }: { className?: string, children?: React.ReactNode }) {
  return <div className={ className } style={{ display: 'flex', alignItems: 'center' }}>
    <div className="u-borderT u-mrs" style={{ flexGrow: 1 }}></div>
    { children }
    <div className="u-borderT u-mls" style={{ flexGrow: 1 }}></div>
  </div>
}